import FilterBox from './FilterBox';
import FilterBoxList from './FilterBoxList';

export default function TypeFilter({
	filters,
	setFilters,
	filtersForStorage,
	setFiltersForStorage
}) {
	const types = [
		{
			name: 'Aktører',
			slug: 'actor',
			color: 'bg-light-red'
		},
		{
			name: 'Organisasjoner',
			slug: 'organization',
			color: 'bg-light-yellow'
		},
		{
			name: 'Personer',
			slug: 'person',
			color: 'bg-light-blue'
		}
	];

	return (
		<FilterBox title="Type">
			<FilterBoxList
				items={types}
				filters={filters}
				setFilters={setFilters}
				filtersForStorage={filtersForStorage}
				setFiltersForStorage={setFiltersForStorage}
				filterKey="types"
			/>
		</FilterBox>
	);
}
